import classNames from 'classnames';
import React from 'react';
// eslint-disable-next-line no-restricted-imports
import { BoardModel, BoardsMenuCategoryType } from 'types/models';

// eslint-disable-next-line no-restricted-imports
import { TestId } from '@trello/webdriverio-tests';
// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import { smallestPreviewBiggerThan } from 'common/lib/util/preview';
// eslint-disable-next-line no-restricted-imports
import { CloseBoardButton, StarredBoardButton } from 'components/board-buttons';
// eslint-disable-next-line no-restricted-imports
import RouterLink from 'common/components/singlespa/router-link';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
import styles from './compact-board-tile.less';

const paddingStyle = (isUnread: boolean, isRecent: boolean) => {
  if (isUnread && isRecent) {
    return styles.threeIcon;
  } else if (isUnread || isRecent) {
    return styles.twoIcon;
  } else {
    return styles.oneIcon;
  }
};

const getBackgroundStyle = (background?: BoardModel['background']) => {
  const css: React.CSSProperties = {};

  if (background) {
    const image = background.tile
      ? background
      : // some old boards have not gone through image scaling,
        // so <board response>.prefs.backgroundImageScaled === null
        smallestPreviewBiggerThan(background.scaled, 400, 200) || background;

    if (image) {
      css.backgroundImage = `url('${image.url}')`;
    }

    css.backgroundColor = background.color || undefined;
  }

  return css;
};

export interface CompactBoardTileProps {
  readonly board: BoardModel;
  readonly boardTileClassName?: string;
  readonly focused?: boolean;
  readonly isStarred: boolean;
  readonly isDragging?: boolean;
  readonly showTeamName?: boolean;
  readonly teamName?: string;
  readonly testId?: TestId;
  readonly type?: BoardsMenuCategoryType;
}

export const CompactBoardTile: React.FunctionComponent<
  CompactBoardTileProps
> = ({
  board,
  boardTileClassName,
  focused,
  isDragging,
  isStarred,
  showTeamName,
  teamName,
  testId,
  type,
}) => {
  const sendAnalytics = () => {
    Analytics.trackUE({
      category: Noun.BOARDS_MENU,
      verb: Verb.OPENS,
      directObj: Noun.BOARD,
      context: {
        id: board.id,
      },
    });
  };
  const { background, id, name, url, isUnread } = board;
  const backgroundStyle = getBackgroundStyle(background);
  const boardBackgroundStyles = classNames(
    styles.boardBackground,
    background && background.tile && styles.modTiled,
  );
  const containerStyles = classNames(
    styles.boardTile,
    boardTileClassName,
    focused && styles.isNavigationFocused,
    isDragging && styles.isDragging,
  );
  const boardLinkStyles = classNames(
    styles.boardLink,
    paddingStyle(isUnread || false, type === BoardsMenuCategoryType.Recent),
  );
  const boardDescriptionStyles = classNames(
    styles.boardDescription,
    teamName && showTeamName && styles.fullHeight,
  );

  const starStyles = classNames(
    styles.utilityAction,
    isStarred && styles.isStarred,
    type === BoardsMenuCategoryType.Recent
      ? styles.actionLarge
      : styles.actionSmall,
  );
  const unreadStyles = classNames(
    styles.unreadMarker,
    isUnread && styles.isUnread,
  );

  return (
    <div className={containerStyles} key={id}>
      <RouterLink
        href={url}
        className={boardLinkStyles}
        onDragStart={(e) => e.preventDefault()}
        title={name}
        data-test-id={testId}
        onClick={sendAnalytics}
      >
        <div className={boardBackgroundStyles} style={backgroundStyle} />
        <div className={styles.boardThumbnail} style={backgroundStyle} />
        <div className={boardDescriptionStyles}>
          <div className={styles.boardName}>{name}</div>
          {teamName &&
            showTeamName && (
              <div className={styles.boardSubName}>{teamName}</div>
            )}
        </div>
        <div className={styles.actionsWrapper}>
          {isUnread && <div className={unreadStyles} />}
          <div className={starStyles}>
            {type === BoardsMenuCategoryType.Recent && (
              <CloseBoardButton {...this.props} idBoard={id} tabIndex={-1} />
            )}
            <StarredBoardButton {...this.props} idBoard={id} />
          </div>
        </div>
      </RouterLink>
    </div>
  );
};



// WEBPACK FOOTER //
// ./app/gamma/src/components/compact-board-tile/compact-board-tile.tsx